"use client"
import {
  transitions
} from "./chunk-XMSTZ4W3.mjs";
import {
  zIndices
} from "./chunk-MM4EOFVO.mjs";
import {
  gradients
} from "./chunk-VTYXYIEH.mjs";
import {
  letterSpacings
} from "./chunk-ZXI4IIHA.mjs";
import {
  lineHeights
} from "./chunk-7R772KLP.mjs";
import {
  radii
} from "./chunk-UCYF6IEQ.mjs";
import {
  shadows
} from "./chunk-D7NNQ2IH.mjs";
import {
  sizes
} from "./chunk-KZAQGQCP.mjs";
import {
  spaces
} from "./chunk-T3VVQOJ3.mjs";
import {
  animations
} from "./chunk-ED2GXCUK.mjs";
import {
  blurs
} from "./chunk-63SXWKLC.mjs";
import {
  borders
} from "./chunk-LHQU6H4M.mjs";
import {
  breakpoints
} from "./chunk-LVSXNUER.mjs";
import {
  colors
} from "./chunk-5PB6LHRL.mjs";
import {
  fontSizes
} from "./chunk-BAO3K26B.mjs";
import {
  fontWeights
} from "./chunk-PLCZVXUS.mjs";
import {
  fonts
} from "./chunk-H2JZLG5X.mjs";

// src/tokens/index.ts
var tokens = {
  animations,
  blurs,
  borders,
  breakpoints,
  colors,
  fonts,
  fontSizes,
  fontWeights,
  gradients,
  letterSpacings,
  lineHeights,
  radii,
  shadows,
  sizes,
  spaces,
  transitions,
  zIndices
};

export {
  tokens
};
//# sourceMappingURL=chunk-ANWDLY3U.mjs.map